var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,47.08a1.5,1.5,0,0,0,3,0V10.46A1.5,1.5,0,0,0,53.54,9H12V4A1.5,1.5,0,0,0,9,4V9H4a1.5,1.5,0,0,0,0,3H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,52H12V16.92a1.5,1.5,0,0,0-3,0V53.54a1.5,1.5,0,0,0,1.5,1.5H52v5a1.5,1.5,0,0,0,3,0V55h5A1.5,1.5,0,0,0,60,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51,15a1.51,1.51,0,0,0-1.5,1.5V37.29a1.4,1.4,0,0,0,0,.29v9.91a1.51,1.51,0,0,0,1.5,1.5h31a1.51,1.51,0,0,0,1.5-1.5v-31a1.51,1.51,0,0,0-1.5-1.5ZM18,18H46V31.69L39.24,25a1.51,1.51,0,0,0-2.12,0s-4.7,4.71-6.91,6.91l-2.4-2.71a1.51,1.51,0,0,0-2-.22L18,34.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.72d9417a57ff62f7a9c328688f961f6c.svg";
export { ForwardRef as ReactComponent };